var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.768209 0C0.344145 0 0 0.360236 0 0.802132V17.1995C0 17.6414 0.344145 18 0.768209 18L19.2302 17.8815C19.6551 17.8815 20 17.523 20 17.081V0.802132C20 0.360219 19.6551 0 19.2302 0H0.768209ZM1 5.2H19V17H1V5.2ZM14.4995 4.10377C15.3303 4.10377 16 3.43345 16 2.6029C16 1.77237 15.3303 1.1 14.4995 1.1C13.6687 1.1 13 1.77237 13 2.6029C13 3.43345 13.6687 4.10377 14.4995 4.10377ZM5.49949 1.1C6.3287 1.1 7 1.77237 7 2.6029C7 3.43345 6.3287 4.10377 5.49949 4.10377C4.67029 4.10377 4 3.43345 4 2.6029C4 1.77237 4.67029 1.1 5.49949 1.1ZM10.8569 14.0993H9.14312V11.9569H7V10.2424H9.14312V8.1H10.8569V10.2424H13V11.9569H10.8569V14.0993Z",
    fill: "#4C4C4C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CalendarIcon.43c21952663aa65b8a3209c1af98d8b3.svg";